/**
 * Created by mauget on 3/7/16.
 */

// PageInstanceView.js

import $ from 'jquery';
import { View } from 'backbone';
import eventBus from 'EventBus.js';
import pageSyncService from 'PageSyncService.js';

//=================================================================================================
// An instance of PageInstanceView is a shim held by the single PageView that holds two canvases and the
// drop shadow. Each instance of PageInstanceView anchors a collection of control views.
// PageInstancefactory instantiates PageInstanceView.
//
// -Lou Mauget, March 7, 2016
//=================================================================================================

class PageInstanceView extends View {

    initialize(opts) {
        this.options = opts || {};
        this.events = {
        };

        // Listen to assets deletion        
        this.listenTo(eventBus, 'assetDeletedEvent', this.assetDeletedEvent);
    }

    //==========================================================================
    // Implements standard BackBone View render method.
    //==========================================================================
    render() {
        this.delegateEvents();
        return this;
    }

    assetDeletedEvent(type, assetId) {
        var currentImageId = this.model.get('backgroundImageAssetId');
        // If asset id is same with our background asset it
        if (currentImageId === assetId) {
            // Restore default
            this.model.set('backgroundImageAssetId', '~pageBgImage');
            pageSyncService.renderCurrentPageView();
        }
    }

    remove() {
        this.undelegateEvents();
        this.stopListening();
        this.off();

        this.$el.empty();
        super.remove();
    }
}

export default PageInstanceView;
